<template>
    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
        <div class="row">
            <h1 class="page-header">
                <!-- {{.Title}} -->
                User Managment
            </h1>
        </div>
        <div id="flashes" class="row">
            <!-- {{template "flashes" .Flashes}} -->
        </div>
        <div class="row">
            <button type="button" class="btn btn-primary" id="new_button" data-toggle="modal"  data-backdrop="static"
                data-user-id="-1" data-target="#modal">
                <i class="fa fa-plus"></i> New User</button>
        </div>
        &nbsp;
        <div id="loading">
            <i class="fa fa-spinner fa-spin fa-4x"></i>
        </div>
        <div class="row">
            <table id="userTable" class="table" style="display:none;">
                <thead>
                    <tr>
                        <th>Username</th>
                        <th>Role</th>
                        <th>Related Customer</th>
                        <th>Last Login</th>
                        <th class="col-md-2 no-sort"></th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="modalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="userModalLabel">New User</h4>
                </div>
                <div class="modal-body" id="modal_body">
                    <div class="row" id="modal.flashes"></div>
                    <form id="usermgt_form">
                        <label class="control-label" for="username"><span>*</span>Username:</label>
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Username" name="username" id="username" autofocus required />
                        </div>
                        <label class="control-label" for="password"><span>*</span>Password:</label>
                        <div class="form-group">
                            <div id="passwordHelpBlock" class="form-text">
                            Your password must be at least 8 characters long, contain upper and lower letters and special characters.
                            </div>
                            <input type="password" class="form-control" autocomplete="new-password" placeholder="Password" name="password" id="password" required />
                            <div class="hidden" id="password-strength-container">
                                <div class="progress" id="password-strength">
                                    <div id="password-strength-bar" class="progress-bar" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <span id="password-strength-description"></span>
                            </div>
                        </div>
                        <label class="control-label" for="confirm_password"><span>*</span>Confirm Password:</label>
                        <div class="form-group">
                            <input type="password" class="form-control" placeholder="Confirm Password" name ="confirmpassword" id="confirm_password"
                                required />
                        </div>
                        <div class="checkbox checkbox-primary">
                            <input id="force_password_change_checkbox" type="checkbox" checked>
                            <label for="force_password_change_checkbox">Require the user to set a new password</label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <input id="account_locked_checkbox" type="checkbox">
                            <label for="account_locked_checkbox">Account Locked</label>
                        </div>
                        <label class="control-label" for="role"><span>*</span>Role:</label>
                        <div class="form-group" id="role-select">
                            <select class="form-control selectbox" placeholder="" name="role" id="role" required >
                                <option selected disabled value=""></option>
                                <option value="admin">Admin</option>
                                <option value="user">User</option>
                                <option value="reader">Reader</option>
                            </select>
                        </div>
                        <label class="control-label" for="customers"><span>*</span>Related customer:</label>
                        <div class="form-group" id="customer-select">
                            <select class="form-control selectbox" placeholder="" name="customers" id="customers" required >
                                <option selected disabled value=""></option>
                            </select>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" id="modalSubmit">Save changes</button>
                </div>
            </div>
        </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'UserManagmentComponent',
    //props: {
    //  msg: String
    //}
    mounted() {

    let customScript = document.createElement('script')
    customScript.setAttribute('src', '/scripts/users.js')
    customScript.setAttribute('type', 'application/javascript')
    document.head.appendChild(customScript)

    let customScript2 = document.createElement('script')

    customScript2.setAttribute('src', '/scripts/utils.js')

    customScript2.setAttribute('type', 'application/javascript')

    document.head.appendChild(customScript2)
}
  }
  </script>
  
  <style>

  #passwordHelpBlock {
    color: grey;
    font-size: 1.2rem;
    text-align:left;
  }
  
  </style>
  